/*
 * SUGGESTIONS COMPONENT
 *
 * RENDERS A ROW OF PRESET SUGGESTION BUTTONS WITH A QUESTION MARK ICON.
 * HIDES IT IF THE USER HAS ALREADY INTERACTED WITH THE CHAT (sessionStorage FLAG).
 * CALLS onClick WITH THE SUGGESTION TEXT WHEN A BUTTON IS CLICKED.
 * ADDS ROBUST ERROR HANDLING FOR STORAGE ACCESS AND DATA SHAPE VALIDATION.
 */

import React from 'react';
import PropTypes from 'prop-types';
import styles from './Suggestions.module.scss';
import all_suggestions from './All_suggestions.js';

/**
 * @param {Object} props
 * @param {(suggestion: string) => void} props.onClick – Callback invoked when a suggestion is clicked.
 */
const Suggestions = ({ onClick }) => {
  // Guard: ensure onClick is a function
  if (typeof onClick !== 'function') {
    console.error('Suggestions: onClick prop is required and must be a function');
    return null;
  }

  // Check if user already interacted
  let interacted = false;
  try {
    interacted = sessionStorage.getItem('chatInteracted') === 'true';
  } catch (err) {
    console.warn('Suggestions: could not read sessionStorage flag', err);
  }
  if (interacted) {
    return null;
  }

  // Load suggestions array safely
  let suggestions = [];
  try {
    const data = all_suggestions.course_recommendation;
    if (Array.isArray(data)) {
      suggestions = data;
    } else {
      console.error('Suggestions: expected course_recommendation to be an array');
    }
  } catch (err) {
    console.error('Suggestions: error loading suggestions data', err);
  }

  // If no valid suggestions, render nothing
  if (suggestions.length === 0) {
    return null;
  }

  return (
    <div className={styles.suggestionContainer}>
      <img
        src="/assets/questionMark.svg"
        alt="Question Icon"
        className={styles.icon}
      />
      {suggestions.map((suggestion, idx) => (
        <button
          key={idx}
          className={styles.suggestionButton}
          onClick={() => {
            try {
              onClick(suggestion);
            } catch (err) {
              console.error('Suggestions: error in onClick handler', err);
            }
          }}
        >
          {suggestion}
        </button>
      ))}
    </div>
  );
};

Suggestions.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default Suggestions;
